import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { UserVerificationComponent } from './user-verification/user-verification.component';
import { VerifyDomainComponent } from './verify-domain/verify-domain.component';
import { DynamicApplicationComponent } from './dynamic-application/dynamic-application.component';
import { ApplicationAccessVerificationComponent } from './application-access-verification/application-access-verification.component';
import { ApplicationStatusComponent } from './application-status/application-status.component';
import { ApplicationCancelComponent } from './application-cancel/application-cancel.component';

const routes: Routes = [
  {
    path:'',
    component:HomeComponent
  },
  {
    path: 'user-submission-form/:id',
    component: UserVerificationComponent,
  },
  {
    path: 'verify',
    component: VerifyDomainComponent,
  },
  {
    path: 'selected-application/:id',
    component: DynamicApplicationComponent,
  },
  {
    path: 'app-access-verification/:id',
    component: ApplicationAccessVerificationComponent,
  },
  {
    path: 'access/:id',
    component: ApplicationAccessVerificationComponent,
  },
  {
    path: 'cancel/:id',
    component: ApplicationCancelComponent,
  },
  {
    path: 'application-status/:id',
    component: ApplicationStatusComponent,
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],  // Use 'useHash: true' for hash-based routing
  exports: [RouterModule]
})
export class AppRoutingModule { }
